import React from 'react'
import icon1 from '../../assets/img/Message.svg';
import icon2 from '../../assets/img/Lock.svg';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { Form, Button } from 'react-bootstrap';
import './Login.css';




const MyLogin = () => {
    return (
        <section className="accounts_section">
            <Container>
                <div className="accounts_card_main_div">
                    <div className="accounts_title">
                        <h2>Welcome back!</h2>
                        <p>Login to your account to get started!</p>
                    </div>
                    <Form className="accounts_input_main">
                        <div className="accounts_input_div">
                            <input type="email" placeholder='Email' />
                            <img src={icon1} alt="" />
                        </div>
                        <div className="accounts_input_div">
                            <input type="password" placeholder='Password' />
                            <img src={icon2} alt="" />
                        </div>
                    </Form>
                    <div className="forgot_text">
                        <Link path=''>Forget password?</Link>
                    </div>
                    <div className="accounts_btn">
                        <Button>Login</Button>
                    </div>
                    <p className="last_text">Don’t have an account? <Link to="/signup">Sign up</Link></p>
                </div>
            </Container>
        </section>
    )
}

export default MyLogin